import { instance, endpoint } from 'api'

export default {
  postRemoveImg (params) {
    return instance().post(endpoint + '/removeimg/' + params.folder + '/' + params.daydel)
  }
}



// WEBPACK FOOTER //
// ./src/api/removeimg/index.js